import React from "react";
import { parseJSON } from "date-fns";
import { useTranslation } from "react-i18next";
import { Box, styled, Typography } from "@mui/material";
import { HistoricQuote } from "@api";
import { SecuritiesDateAndPriceChart } from "@components";

const ValuesSelectionChartWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const ChartOverlayWrapper = styled(Box)({
  position: "relative",
  minHeight: 300,
});

const NoDataOverlay = styled(Box)({
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  pointerEvents: "none",
  textAlign: "center",
});

interface ValuesSelectionChartContainerProps {
  historicQuotes: HistoricQuote[];
  onSelectDatetimeRange: (range: RangeType) => void;
  onDateChange: (date?: Date) => void;
  onPriceChange: (price: number) => void;
}

export const ValuesSelectionChartContainer = (
  props: ValuesSelectionChartContainerProps
) => {
  const { historicQuotes, onSelectDatetimeRange, onDateChange, onPriceChange } =
    props;

  const { t } = useTranslation();

  const handleSelectDate = (type: IntervalType, range: RangeType) => {
    onSelectDatetimeRange(range);
  };
  const handleValuesSelect = (value?: number, date?: Date) => {
    onDateChange(date);
    onPriceChange(value ?? 0);
  };

  const quotes = historicQuotes.map((item) => ({
    date: parseJSON(item.date),
    value: item.value,
  }));

  const hasData = quotes.length > 0;

  return (
    <ValuesSelectionChartWrapper>
      <Typography variant="body3" color="textSecondary">
        {t("securitiesAddPage.chartHint")}
      </Typography>

      <ChartOverlayWrapper>
        <SecuritiesDateAndPriceChart
          data={quotes}
          onDateSelect={handleSelectDate}
          onValuesSelect={handleValuesSelect}
        />
        {!hasData && (
          <NoDataOverlay>
            <Typography variant="body2" color="textSecondary">
              {t("securitiesAddPage.chartNoData")}
            </Typography>
          </NoDataOverlay>
        )}
      </ChartOverlayWrapper>
    </ValuesSelectionChartWrapper>
  );
};
